import { Component } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { isCognito } from '@gebeya/g-saas-core-mf-shared-ts';
import { ConfigModel } from '../shared/models/config.model';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  microsoft: boolean = false;

  constructor(
    private configService: ConfigService,
  ) {

  }

  ngOnInit(): void {
    this.getConfiguration();
  }

  getConfiguration() {
    this.configService.getConfig().subscribe({
      next: (response: ConfigModel) => {
        if (isCognito(response)) {
          location.href = location.origin + "/talent-cloud/404";
        }
      }
    })
  }

}
